import { render } from "./XIconSolidLayoutDashboard.vue?vue&type=template&id=534934e2"
import script from "./XIconSolidLayoutDashboard.vue?vue&type=script&lang=js"
export * from "./XIconSolidLayoutDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLayoutDashboard.vue"]])

export default __exports__